<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <div class="order-detail-box">
          <div class="label-val">
            <div class="label-1">共识别数据</div>
            <div class="value-1">{{ form.successNum + form.failNum }}条</div>
          </div>
          <div class="label-val">
            <div class="label-1">成功导入</div>
            <div class="value-1 color526bec">{{ form.successNum }}条</div>
          </div>
          <div class="label-val">
            <div class="label-1">失败</div>
            <div class="value-1 colorf32009" >{{ form.failNum }}条</div>
          </div>
        </div>
        <div class="related-orders">
          <custom-table :data="form.failContent" :column="tableColumn" :showPagination="false">
          </custom-table>
        </div>

      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import CustomTable from "@/components/CustomTable.vue";
export default {
  name: "AddOrEdit",
  components: {
    CustomTable,
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "导入成功",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {},
      tableData: [],
      tableColumn: [
        {
          label: "失败数据行号",
          prop: "rowNum",
          align: "left",
          show: true
        },
        {
          label: "失败原因",
          prop: "message",
          align: "left",
          show: true,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    init(row) {
      this.form = Object.assign({}, row);
      this.dialogObj.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.14rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .related-orders {
    background: #f7f8fb;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
  }
}
</style>
